import React, { useEffect, useState } from 'react';
import styles from './NumberKeypad.module.css';
import classNames from 'classnames';

const sizeConfig = {
  'xsmall': {
    height: '8vh',
    width: '10vh',
  },
  'small': {
    height: '10vh',
    width: '12vh',
  },
  'medium': {
    height: '12vh',
    width: '14vh',
  },
  'large': {
    height: '14vh',
    width: '16vh',
  },
  'xsmall_square': {
    height: '10vh',
    width: '10vh',
  },
  'small_square': {
    height: '12vh',
    width: '12vh',
  },
  'medium_square': {
    height: '14vh',
    width: '14vh',
  },
  'large_square': {
    height: '16vh',
    width: '16vh',
  },
  'xlarge_square': {
    height: '18vh',
    width: '18vh',
  },
};

const NumberKeypad = (props) => {
  const { onClick, needDecimal, size = 'small', extraButtons = [], keypadKeyStyle, paymentAmt, currency } = props;
  const keyboardConfig = sizeConfig[size];
  const config = {
    medium: [
      [
        {
          text: 1,
        },
        {
          text: 2,
        },
        {
          text: 3,
        },
      ],
      [
        {
          text: 4,
        },
        {
          text: 5,
        },
        {
          text: 6,
        },
      ],
      [
        {
          text: 7,
        },
        {
          text: 8,
        },
        {
          text: 9,
        },
      ],
      [
        {
          text: needDecimal ? '.' : '',
        },
        {
          text: 0,
        },
        {
          text: 'X',
          type: 'back',
          icon: 'ios-backspace',
        },
      ],
    ],
  };
  const [buttonConfig, setButtonConfig] = useState(config);

  useEffect(() => {
    if (extraButtons && extraButtons.length) {
      let newBtns = [...buttonConfig.medium];
      extraButtons.forEach((btn, index) => {
        newBtns[index].push({ text: btn.value, type: 'extra', mode: btn.type })
      });
      setButtonConfig({ medium: newBtns });
    }
  }, []);

  return (
    <div className={styles.keypad}>
      {buttonConfig['medium'].map((row, index) => (
        <div key={`keypad-row-${index.toString()}`} className={styles.keypadRow}>
          {row.map((key, i) => (
            <div style={keyboardConfig}
              className={classNames({ [styles.keypadKey]: true, [styles.payment]: key.mode === 'payment', [styles.extraBtn]: key.type === 'extra', [keypadKeyStyle]: true })}
              onClick={() => onClick(key.text, key.type, key.mode, paymentAmt)}
              key={`key-${i.toString()}`}
            >
              {key.mode === 'payment' ? <span className={styles.amount}>{currency}{paymentAmt}</span> : key.text}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default NumberKeypad;
